<template>
  <div class="_login-wrapper"></div>
</template>

<script>
import store from "../store";
export default {
  async mounted() {
    await this.$nextTick();
    console.log("Logout");
    store.dispatch("auth/logout");
    // this.$router.push("/login");
    // window.location = "/login";
    window.location.replace("/login");
  },
};
</script>

<style></style>
